import '../../../sass/screens/balance_of_deposit/index.scss';
import { PAY_BY_CARD_EVENTS } from '../../event_bus_modules/pay_by_card';
import { refundFormInitialisation } from '../../components/refund_form';


$(() => {
    const SELECTORS = {
        CONTAINER: $('#pay-balance-of-deposit-container'),
        CARD_PAYMENT_BUTTON: $('#card-payment-button'),
        REFUND_DETAILS_SUBMIT_BUTTON: $('button[name="submit-refund-button"]'),
        NAVIGATION_CARD: $('#nav-card-payment-tab'),
        NAVIGATION_BANK: $('#nav-bank-payment-tab')
    }
    const csrfToken = SELECTORS.CONTAINER.find(
        'input[name="csrfmiddlewaretoken"]'
    ).val();
    const bidderId = SELECTORS.CONTAINER.find(
        'input[name="bidderId"]'
    ).val()

    const userBankDetailsCountrySelect = $('#bod-user-bank-details-country-select');
    const USER_BANK_DETAILS_FORM_PER_COUNTRY = {
      ireland: $('#bod-bank-transfer-user-details-form-ireland-cyprus'),
      cyprus: $('#bod-bank-transfer-user-details-form-ireland-cyprus'),
      'south africa': $('#bod-bank-transfer-user-details-form-south-africa'),
      spain: $('#bod-bank-transfer-user-details-form-spain'),
      'united kingdom': $('#bod-bank-transfer-user-details-form-united-kingdom'),
    };

    const countryOfAuction = $('#bod-country-of-auction').val()?.toLowerCase();
    const currentCountryName = $('#bod-selected-country-name').val()?.toLowerCase();
    const auctionIdentifier = $('#auction-identifier').val()?.toLowerCase();
    const errorsContainer = $('#pay-balance-of-deposit-container').find('.form-errors')

    const requestCardPayment = () => {
        SELECTORS.CARD_PAYMENT_BUTTON.attr('disabled','disabled');
        EVENT_BUS.dispatch(PAY_BY_CARD_EVENTS.BOD_REQUEST_PAYMENT_BY_CARD, {
            bidderId, csrfToken,
        });
    }


    SELECTORS.NAVIGATION_BANK.on('click', () => {
        SELECTORS.NAVIGATION_BANK.removeClass('inactive');
        SELECTORS.NAVIGATION_CARD.addClass('inactive');
    });

    SELECTORS.NAVIGATION_CARD.on('click', () => {
        SELECTORS.NAVIGATION_CARD.removeClass('inactive');
        SELECTORS.NAVIGATION_BANK.addClass('inactive');
    });

    SELECTORS.CARD_PAYMENT_BUTTON.on('click', requestCardPayment);

    refundFormInitialisation(
      userBankDetailsCountrySelect,
      USER_BANK_DETAILS_FORM_PER_COUNTRY,
      countryOfAuction,
      currentCountryName,
      true,
    )
});